export const LOGGING_USER_IN = 'auth/login/logging_user_in';
export const LOGIN_SUCCESS = 'auth/login/login_success';
export const LOGIN_ERROR = 'auth/login/login_error';
